import React, { useEffect, useState } from "react";
import "../style/LoaderBoletines.css";

export default function LoaderBoletines({ visible, etapa = "Procesando..." }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!visible) {
      setProgress(0);
      return;
    }

    let value = 0;

    const interval = setInterval(() => {
      value += Math.random() * 8;

      if (value >= 95) value = 95;

      setProgress(Math.floor(value));
    }, 800);

    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="overlay-loader-boletin">
      <div className="loader-box-boletin">
        <div className="spinner-boletin"></div>

        <h2>Generando Boletines</h2>
        <p>{etapa}</p>

        <div className="progress-container-boletin">
          <div
            className="progress-bar-boletin"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <span>{progress}%</span>
      </div>
    </div>
  );
}
